import BaseHandler from './baseHandler';
import { ENTRY_STATUS_EVENTS } from './utils';

/**
 * EntryStatusHandler Class
 * Manages entry status subscriptions using event-based approach (no polling)
 * Extends BaseHandler for common functionality
 */
class EntryStatusHandler extends BaseHandler {
  constructor(socketClient, config = {}) {
    const events = {
      GET_ENTRY_STATUS: config.GET_ENTRY_STATUS || ENTRY_STATUS_EVENTS.GET_ENTRY_STATUS,
      GET_ENTRY_STATUS_RESPONSE: config.GET_ENTRY_STATUS_RESPONSE || ENTRY_STATUS_EVENTS.GET_ENTRY_STATUS_RESPONSE,
      DISCONNECT: config.DISCONNECT || ENTRY_STATUS_EVENTS.DISCONNECT,
    };
    
    super(socketClient, events, 'EntryStatusHandler');
    this.currentToken = null;
  }

  //  Starts listening to entry status updates for a shipment
  startListening(shipmentId, token, callback, options = {}) {
    this.stopListening();

    if (!shipmentId || !token) {
      console.warn(`[${this.handlerName}] Cannot start listening: shipmentId or token missing`);
      return;
    }

    if (!this._checkConnection('start listening')) {
      return;
    }

    this.currentShipmentId = shipmentId;
    this.currentToken = token;
    this.callback = callback;

    // Emit event to backend to start monitoring
    this._emitEvent(this.events.GET_ENTRY_STATUS, { shipmentId, token });

    // Subscribe to entry status response events
    this.unsubscribe = this._subscribe(
      this.events.GET_ENTRY_STATUS_RESPONSE,
      shipmentId,
      callback
    );

    console.log(`[${this.handlerName}] Started listening for shipment: ${shipmentId}`);
  }

  //  Stops listening to entry status updates
  stopListening() {
    this._cleanup();
    this.currentToken = null;
    console.log(`[${this.handlerName}] Stopped listening`);
  }
}

export default EntryStatusHandler;
